import { jsx as _jsx } from "react/jsx-runtime";
import ProfileContainer from "@components/profile-container";
import React from "react";
var ProductProfile = function(param) {
    var guestData = param.guestData, product = param.product;
    return /*#__PURE__*/ _jsx(ProfileContainer, {
        isResultPage: true,
        guestData: guestData,
        profileData: product,
        type: "products"
    });
};
export var __N_SSG = true;
export default ProductProfile;
